import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import MirassoLogo from '../assets/Mirasso_logo.png'
import { AuthService } from '../services/auth'
import TermsDialog from './TermsDialog'

const Footer = () => {
  const navigate = useNavigate()
  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const handleLogout = async () => {
    try {
      await AuthService.signOut()
      navigate('/')
      window.scrollTo(0, 0)
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <>
      <footer className="bg-[#ffffff] border-t border-[#f9f4f4] mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Left Column - Logo and Navigation */}
            <div className="space-y-6">
              {/* Logo */}
              <div>
                <a href="https://mirasso.co.jp/" target="_blank" rel="noopener noreferrer">
                  <img src={MirassoLogo} alt="Mirasso" className="h-12" />
                </a>
              </div>
                            
              {/* Navigation Links */}
              <div className="space-y-3">
                <div className="block text-[#666666] transition-colors text-sm">
                  問い合わせ <a href="mailto:mirapass@mirasso.co.jp" className="hover:text-[#da4574] transition-colors">mirapass@mirasso.co.jp</a>
                </div>
                <button
                  onClick={() => setIsTermsDialogOpen(true)}
                  className="block text-left text-[#666666] hover:text-[#da4574] transition-colors text-sm"
                >
                  利用規約
                </button>
                <button
                  onClick={handleLogout}
                  className="block text-left text-[#666666] hover:text-[#da4574] transition-colors text-sm"
                >
                  ログアウト
                </button>
              </div>
            </div>
            
          </div>
          
          {/* Scroll to Top Button */}
          <div className="flex justify-center mt-8">
            <button
              onClick={scrollToTop}
              className="bg-[#da4574] hover:bg-[#c63a68] text-white p-3 rounded-full transition-colors shadow-lg"
              aria-label="ページトップへ戻る"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </footer>

      {/* Terms Dialog */}
      <TermsDialog
        isOpen={isTermsDialogOpen}
        onClose={() => setIsTermsDialogOpen(false)}
      />

      {/* Copyright with gradient */}
      <div className="bg-gradient-to-r from-[#F472B6] via-[#FBBF24] via-[#FB923C] to-[#5EEAD4] py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="text-center text-white text-sm">
            © 2025 Mirasso inc. All rights reserved.
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer